<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2.06,6.69C2.2,6.29,2.56,6,3,6C3,6,14,6,14,6C14,6,14,5,14,5C14,4.45,13.55,4,13,4C13,4,6.41,4,6.41,4C6.41,4,4.71,2.29,4.71,2.29C4.53,2.11,4.28,2,4,2C4,2,1,2,1,2C0.45,2,0,2.45,0,3C0,3,0,12.84,0,12.84C0,12.84,2.05,6.69,2.05,6.69C2.05,6.69,2.06,6.69,2.06,6.69C2.06,6.69,2.06,6.69,2.06,6.69ZM16,8C16,7.45,15.55,7,15,7C15,7,4,7,4,7C3.56,7,3.19,7.29,3.06,7.69C3.06,7.69,3.06,7.69,3.06,7.69C3.06,7.69,1.06,13.69,1.06,13.69C1.06,13.69,1.06,13.69,1.06,13.69C1.02,13.78,1,13.89,1,14C1,14.55,1.45,15,2,15C2,15,13,15,13,15C13.44,15,13.81,14.71,13.94,14.31C13.94,14.31,13.94,14.31,13.94,14.31C13.94,14.31,15.94,8.309999999999999,15.94,8.309999999999999C15.94,8.309999999999999,15.94,8.309999999999999,15.94,8.309999999999999C15.98,8.219999999999999,16,8.11,16,8C16,8,16,8,16,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FolderOpen',
} as DefineComponent
</script>
